var exports = {
  "k": "xa15a2ab7--f635bd--container",
};

module.exports = exports;
